import React, { JSX, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Heading } from '@chakra-ui/react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { REDIRECTES } from 'utils/redirects'

const NotFound = (): JSX.Element => {
  const { t } = useTranslation(['common'])

  const router = useRouter()

  useEffect(() => {
    makeClientRedirection()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router])

  // These redirects should be done in `redirects` method in next.config.js,
  // but it doesn't work as it should. I've tried combination of `redirects` and `rewrites`
  // as well, but still I got 404.
  const makeClientRedirection = () => {
    const currentUrl = window.location.href

    for (const url of REDIRECTES) {
      if (decodeURIComponent(currentUrl).includes(decodeURIComponent(url.source))) {
        router.push(url.destination)
        return
      }
    }
  }

  return (
    <Box textAlign="center" marginTop="100px">
      <Heading mb="24px" lineHeight={{ base: 1.33, md: 1.2 }}>
        {t('common:notFound')}
      </Heading>
      <Link href="/">{t('common:goToHomePageLink')}</Link>
    </Box>
  )
}

export default NotFound
